import { render, staticRenderFns } from "./PromptError.vue?vue&type=template&id=34f8cb1e&scoped=true&"
import script from "./PromptError.vue?vue&type=script&lang=js&"
export * from "./PromptError.vue?vue&type=script&lang=js&"
import style0 from "./PromptError.vue?vue&type=style&index=0&id=34f8cb1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f8cb1e",
  null
  
)

export default component.exports